import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class DueColumn extends Column {
    title = 'Due';
    property = 'dueAt';
    type: CellDisplay = CellDisplay.string;
}
